/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_CopiedInputs */



/**
* | output |
* | --- |
* | "Recovery code copied to clipboard" |
*
* @param {Auth_Recovery_Code_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_copied = /** @type {((inputs?: Auth_Recovery_Code_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellungscode in die Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("Recovery code copied to clipboard")
});